import React from 'react'
import Button from '@mui/material/Button';

function DTMF({onKeyPress}) {

  const renderButton = (key, primary) => {
    let component = 
        <Button 
            color={primary ? 'primary' : 'neutral'}
            sx={{
                width: '4rem',
                height: '4rem'
            }}
            variant="contained"
            size="large"
            onClick={() => onKeyPress(key)}
        >
            {key}
        </Button>
    return component
  }

  return (
    <div className='live-call-dtmf-pad'>
        <div className='live-call-dtmf-pad-row'>
            {renderButton(1, true)}
            {renderButton(2, true)}
            {renderButton(3, true)}
        </div>
        <div className='live-call-dtmf-pad-row'>
            {renderButton(4, true)}
            {renderButton(5, true)}
            {renderButton(6, true)}
        </div>
        <div className='live-call-dtmf-pad-row'>
            {renderButton(7, true)}
            {renderButton(8, true)}
            {renderButton(9, true)}
        </div>
        <div className='live-call-dtmf-pad-row'>
            {renderButton('*', false)}
            {renderButton(0, true)}
            {renderButton('#', false)}
        </div>
    </div>
  )
}

export default DTMF